var _rect, _rect2, _rect3, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _path13, _path14, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRewardsRecognitionsLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 86,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 800,
    transform: "translate(-713 -198)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -79,
    y: -24,
    width: 258,
    height: 198,
    rx: 3,
    stroke: "#5D5CF5",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.3324,
    cy: 42.6594,
    rx: 38,
    ry: 53.5,
    transform: "rotate(-60 50.3324 42.6594)",
    fill: "#F2F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0097 38.7082C45.7779 38.7082 46.3463 38.6698 46.4039 38.666L46.3002 37.1297C46.2618 37.1297 42.713 37.364 40.8887 36.6228C39.437 36.0198 37.8393 31.9487 37.1249 28.3385C36.6756 26.0533 36.9214 25.3351 37.1249 25.1085C37.1633 25.0586 37.2709 24.928 37.6818 24.928H39.099C39.5061 26.1609 40.1629 27.4014 41.1499 27.4014H43.9843V25.8651H41.2421C40.8475 25.2804 40.5601 24.6302 40.3933 23.9448L40.2358 23.3803H37.6588C37.3321 23.3621 37.0056 23.4188 36.7041 23.5459C36.4026 23.673 36.1341 23.8673 35.919 24.1138C35.2545 24.9242 35.1508 26.3145 35.6156 28.6266C35.9823 30.4884 36.5302 32.3098 37.2517 34.0649C38.1811 36.2579 39.2142 37.5983 40.3242 38.0438C41.6799 38.6045 43.6732 38.7082 45.0097 38.7082Z",
    fill: "#F2D283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.857 38.7085C59.0889 38.7085 58.5205 38.6701 58.4629 38.6662L58.5666 37.13C58.605 37.13 62.1537 37.3642 63.978 36.623C65.4298 36.0354 67.0313 31.9528 67.7418 28.3426C68.1912 26.0574 67.9454 25.3392 67.7418 25.1126C67.7034 25.0627 67.5959 24.9321 67.185 24.9321H65.7678C65.3607 26.165 64.7039 27.4055 63.7169 27.4055H60.8825V25.8692H63.6247C64.0192 25.2845 64.3066 24.6343 64.4735 23.9489L64.6309 23.3843H67.208C67.5344 23.3657 67.8607 23.4218 68.1622 23.5482C68.4637 23.6747 68.7323 23.8682 68.9478 24.1141C69.6122 24.9244 69.7159 26.3147 69.2512 28.6268C68.8845 30.4886 68.3365 32.3101 67.6151 34.0651C66.6857 36.2581 65.6526 37.5985 64.5426 38.044C63.1869 38.6048 61.1936 38.7085 59.857 38.7085Z",
    fill: "#F2D283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3574 54.1591V55.0309H60.5111V54.1591H59.1285L58.0954 52.6804L53.3944 50.81V41.6348H51.4741V50.81L46.7732 52.6804L45.7401 54.1591H44.3574Z",
    fill: "#F2D283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9397 42.8613H53.9238V41.8973H50.9397V42.8613Z",
    fill: "#E8C36A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5547 22.3516C42.5547 22.3516 43.3228 34.849 45.2815 38.3056C47.2403 41.7621 51.4534 42.054 52.4328 42.054C53.4122 42.054 57.6176 41.7583 59.5841 38.3056C61.5505 34.8528 62.3109 22.3516 62.3109 22.3516H42.5547Z",
    fill: "#F2D283"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.9311 41.9119C49.2335 41.6277 46.6872 40.7597 45.2777 38.3056C43.3075 34.849 42.5547 22.3516 42.5547 22.3516H44.4097C44.667 24.9747 45.1778 35.0026 46.5912 37.9176C47.824 40.4678 50.7314 41.8389 50.9311 41.9119Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1287 54.1646H45.7402L46.441 53.166H58.4297L59.1287 54.1646Z",
    fill: "#E8C36A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4335 26.3008L53.4935 28.4515L55.8708 28.7972L54.1502 30.4717L54.5573 32.8337L52.4335 31.7199L50.3096 32.8337L50.7167 30.4717L48.9961 28.7972L51.3734 28.4515L52.4335 26.3008Z",
    fill: "#FEF8E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0664 55.5C40.0664 55.0977 40.3926 54.7715 40.7949 54.7715H64.1083C64.5106 54.7715 64.8368 55.0977 64.8368 55.5V59.1427H40.0664V55.5Z",
    fill: "#CACACA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3301 59.8711C35.3301 59.4688 35.6563 59.1426 36.0586 59.1426H67.7502C68.1525 59.1426 68.4787 59.4688 68.4787 59.8711V63.5138H35.3301V59.8711Z",
    fill: "#BABABB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4535 46.3219L73.8586 46.9696C73.7513 47.0864 73.8342 47.2749 73.9927 47.2749H75.0321C75.1128 47.2749 75.1913 47.3017 75.2551 47.3512L76.0772 47.9876C76.1969 48.0803 76.3709 47.995 76.3709 47.8436V46.8418C76.3709 46.7431 76.4109 46.6486 76.4818 46.58L77.2617 45.8253C77.3793 45.7115 77.2987 45.5123 77.135 45.5123H75.8883C75.8076 45.5123 75.7291 45.4855 75.6653 45.4361L74.8431 44.7996C74.7235 44.7069 74.5495 44.7922 74.5495 44.9436V46.0755C74.5495 46.1667 74.5153 46.2547 74.4535 46.3219Z",
    fill: "#79A2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.698 24.0088L24.5615 24.8776C24.5369 25.0343 24.7103 25.1454 24.8423 25.0575L25.7077 24.4818C25.7749 24.437 25.855 24.4159 25.9355 24.4217L26.9726 24.4962C27.1236 24.507 27.2211 24.3396 27.1373 24.2136L26.5823 23.3795C26.5276 23.2974 26.5086 23.1965 26.5297 23.1001L26.7608 22.0398C26.7957 21.8799 26.6183 21.7587 26.482 21.8494L25.4441 22.54C25.3768 22.5847 25.2967 22.6059 25.2162 22.6001L24.1791 22.5256C24.0281 22.5148 23.9306 22.6821 24.0144 22.8082L24.6414 23.7505C24.692 23.8265 24.7122 23.9186 24.698 24.0088Z",
    fill: "#79A2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4126,
    cy: 32.7329,
    r: 0.728541,
    stroke: "#FDC350",
    strokeWidth: 0.364271
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5533,
    cy: 45.4829,
    r: 0.728541,
    stroke: "#84C8B1",
    strokeWidth: 0.364271
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0293 34.7374L72.6685 33.4624L74.672 34.7374L75.947 32.916",
    stroke: "#79A2FF",
    strokeWidth: 0.364271,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0616 40.0195L37.8795 41.2945L36.2402 41.6587V42.3873",
    stroke: "#84C8B1",
    strokeWidth: 0.364271,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -4023.5,
    y: -1877.5,
    width: 22802,
    height: 4952,
    stroke: "white",
    strokeWidth: 51
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRewardsRecognitionsLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rewards_recognitions_logo.148a61d0.svg";
export { ForwardRef as ReactComponent };